import { render, staticRenderFns } from "./ProductsAdd.vue?vue&type=template&id=19cec6be&"
import script from "./ProductsAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports